import {hooks} from './hooks'

/**
 * Dispatch a route to controller action
 *
 * @public
 * @param {Object} controller - Controller
 * @param {String} actionName - The name of the controller method, or action, to call
 */
module.exports = function dispatch(controller, actionName, options = {}) {

  let collectionName = false

  if(typeof options.collectionName == 'boolean') {
    collectionName = options.collectionName
  }
  else if(actionName == 'getAll') {
    collectionName = true
  }

  const nextMiddleware = (typeof options.next == 'boolean') ? options.next : true

  return async (req, res, next) => {
    const logger = req.logger || console
    if(!logger.debug) {
      logger.debug = console.log.bind(console)
    }

    if(controller && typeof controller.set == 'function') {
      controller.set('logger', logger)
    }

    logger.debug(`Dispatching controller: ${controller.name} & action: ${actionName}`)
    const action = controller[actionName]

    try {
      if(!nextMiddleware) {
        action.call(controller, req, res)
        return
      }

      const beforeHooks = hooks.services.before.get(controller.name)

      if(beforeHooks instanceof Array) {

        for (const hook of beforeHooks) {

          if(hook.actionName == actionName) {
            req = await hook.operation(req, res)
          }
        }
      }

      let pkg    = {},
          status = process.env.HTTP_SUCCESS_CODE || 200

      let result = await action.call(controller, req, res)

      if(req.method == 'POST') status = process.env.HTTP_CREATED_CODE || 201

      // return collection name
      if(collectionName && controller.name) {
        pkg[controller.name] = result
      }
      // return item
      else {
        pkg = result
      }
      //logger.debug(`${actionName}`, pkg)

      let response = {
        pkg,
        status
      }

      // The service name is the controller name
      const afterHooks = hooks.services.after.get(controller.name)

      if(afterHooks instanceof Array) {

        for(const hook of afterHooks) {

          // The action name is the specific action the hook should happen on
          if(hook.actionName == actionName) {

            response = await hook.operation(req, response)

          }
        }

      }

      if(process.env.LOG && process.env.LOG_LEVEL == 'debug') {
        response.req = {
          bodyPolluted: (req.bodyPolluted) ? true : false,
          query: req.query,
          queryPolluted: (req.queryPolluted) ? true : false
        }
      }

      if (options.contentType) {
        req.contentType = options.contentType
      }

      req.response = response

      next()

    }
    catch(err) {
      logger.error(`Action ${actionName} failed; pushing to next middleware`)

      next(err)
    }

  }

}
